// Tamaño mínimo del QR para que la cámara lo enganche: 4 px por módulo, contando el margen.

/** Bytes que caben por versión de QR con corrección L en modo byte (versiones 1 a 40). */
const BYTE_CAPACITY_L = [
    17, 32, 53, 78, 106, 134, 154, 192, 230, 271, 321, 367, 425, 458, 520, 586, 644, 718, 792, 858,
    929, 1003, 1091, 1171, 1273, 1367, 1465, 1528, 1628, 1732, 1840, 1952, 2068, 2188, 2303, 2431,
    2563, 2699, 2809, 2953,
] as const;

export const MIN_PX_PER_MODULE = 4;
/** Margen en módulos por lado; es el `marginSize` del `QRCodeSVG`. */
export const QR_MARGIN_MODULES = 2;
/** Piso visual: una liga corta no debe verse como una estampilla. */
export const QR_MIN_DISPLAY_PX = 240;

/** Módulos por lado del QR que codifica `text` con corrección L. */
export function qrModuleCount(text: string): number {
    const bytes = new TextEncoder().encode(text).length;
    const index = BYTE_CAPACITY_L.findIndex((capacity) => capacity >= bytes);
    const version = index === -1 ? BYTE_CAPACITY_L.length : index + 1;
    return 17 + 4 * version;
}

/** Ancho mínimo en px del QR, margen incluido. */
export function qrMinWidthPx(text: string): number {
    return (qrModuleCount(text) + 2 * QR_MARGIN_MODULES) * MIN_PX_PER_MODULE;
}
